import { useState } from 'react';
import { emailSchema } from '@jbhi-fi/lanyard-ui/utils/ValidationSchema';
import { usePublicApiClient } from './usePublicApiClient';
export type UseKlaviyoBackInStoreSubscribe = () => {
  message: string;
  isLoading: boolean;
  hasError: boolean;
  hasValidationError: boolean;
  onBackInStoreSubscribe: (args: { email: string; listId: string }) => Promise<void>;
};

const FAILURE_MESSAGE = 'Sorry, signup failed. Please try again later.';

export const useBackInStoreSubscribe: UseKlaviyoBackInStoreSubscribe = () => {
  const [message, setMessage] = useState('');
  const [hasError, setHasError] = useState(false);
  const [hasValidationError, setHasValidationError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { klaviyoBackInStoreClient } = usePublicApiClient();

  if (!klaviyoBackInStoreClient) {
    throw new Error('useBackInStoreSubscribe error: klaviyoBackInStoreClient  not provided');
  }

  const onBackInStoreSubscribe = async ({ email, listId }: { email: string; listId: string }) => {
    setMessage('');
    setHasError(false);
    setHasValidationError(false);

    if (isLoading) return;
    try {
      await emailSchema.validate(email);
    } catch (err: any) {
      setMessage(err.message);
      setHasError(true);
      setHasValidationError(true);
      return;
    }

    setIsLoading(true);
    const { error } = await klaviyoBackInStoreClient.backInStoreSubscribe({ email, listId });
    if (error) {
      setHasError(true);
      setMessage(FAILURE_MESSAGE);
    } else {
      setMessage('Subscribed!');
    }
    setIsLoading(false);
  };

  return { message, isLoading, hasError, hasValidationError, onBackInStoreSubscribe };
};
